import { render, staticRenderFns } from "./UserTypesDropdown.vue?vue&type=template&id=145bf502"
import script from "./UserTypesDropdown.vue?vue&type=script&lang=js"
export * from "./UserTypesDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports